import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from "@angular/core";
import { Form, FormArray, FormControl, FormGroup, FormRecord, NonNullableFormBuilder, Validators } from "@angular/forms";
import { WebhookField } from "../../webhook-interfaces/configuration";
import { Variable } from "src/app/forms/formula-tester/formula-tester.component";
import { WebHookCommonServices } from "../../webhook-services/webhook-commom.services";
import { FormServices } from "src/app/services/form.services";
import { Subscription } from "rxjs";


@Component({
    selector: 'webhook-form-section',
    templateUrl: './webhook-form-section.component.html',
    styleUrl: './webhook-form-section.component.scss',
    standalone: false,
})

export class WebhookFormSectionComponent implements OnInit, OnDestroy {
    formRows: number[]=[];
     constructor(
            private fb:NonNullableFormBuilder, 
            private cd:ChangeDetectorRef,
            private commomServices:WebHookCommonServices,
            private fs:FormServices
        
        ) {

    }

    
    editMode:boolean = false;
    private editIndex: number | null = null;

    
    newRow = this.fb.group({});
    @Input() mainformGroup:FormGroup;
    @Output() mainformGroupChange:EventEmitter<FormGroup> = new EventEmitter<FormGroup>();
    @Input() field:WebhookField;
    @Input() variables:Variable[] = [];
    @Input() rootForm:FormGroup;
    @Input() configuration: any;
    @Input()n:number;
    @Input() fieldNew:string;
    sub1:Subscription;
    

    ngOnDestroy(): void {
        if (this.sub1) {
            this.sub1.unsubscribe();
        }
    }

    mergeFormGroups(target: FormGroup, source: FormGroup): void {
        const sourceGroup = source.get(this.field.field) as FormGroup ?? source;

        Object.keys(sourceGroup.controls).forEach((key) => {
            const control = sourceGroup.get(key);
            if (control) {
                if ( control instanceof FormControl) {
                    if (!target.contains(key)) {
                        target.addControl(key, control as FormControl);
                    } else {
                        target.setControl(key, control as FormControl) ;
                    }
                }
                if ( control instanceof FormArray) {
                    if (!target.contains(key)) {
                        target.addControl(key, control as FormArray);
                    } else {
                        target.setControl(key, control as FormArray) ;
                    }
                }
                if ( control instanceof FormGroup) {
                    if (!target.contains(key)) {
                        target.addControl(key, control as FormGroup);
                    } else {
                        target.setControl(key, control as FormGroup) ;
                    }
                }
            }
        });
    }

    
    ngOnInit(): void {    
        this.fieldNew = this.field.field.split('.')[this.n];
        
        this.formRows = [...new Set(this.field.sectionConfiguration.fields.map(item => item.row))];

        this.newRow = this.mainformGroup.get(this.fieldNew) as FormGroup;
        if( Object.keys(this.newRow.controls ).length == 0  ){
             let row:FormGroup =  this.createEmptyRow();

             Object.keys(row.controls).forEach(key=>{
                const control = row.get(key);
                if( control ){
                    this.newRow.addControl(key,control);
                }
             })
        }   

        //this.newRow.addControl('editing', new FormControl<boolean>(false, { nonNullable: true }));
        //this.newRow.addControl('component', new FormControl<Object>(this.field));
 
        this.sub1 = this.newRow.valueChanges.subscribe(value => {
            //(this.newRow as FormGroup).get('editing').setValue(true, { emitEvent: false });
            this.mainformGroupChange.emit(this.mainformGroup);
        });

    }

    clearRow(){
        //(this.newRow as FormGroup).get('editing').setValue(false, { emitEvent: false });
        this.newRow.reset();
    }

    private createEmptyRow(): FormGroup {
        const g = this.fb.group({});
        // Reuse your service to create the same controls/validators
        if ( this.field.tableConfiguration!=null && this.field.tableConfiguration.fields!=null){
            this.field.tableConfiguration.fields.forEach(f => {
                this.commomServices.createControl(f, g);
            });
        }

        if ( this.field.sectionConfiguration!=null && this.field.sectionConfiguration.fields!=null){
            this.field.sectionConfiguration.fields.forEach(f => {
                this.commomServices.createControl(f, g);
            });
        }
        return g;
    }


}
